// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--EOn5e","header":"_02712f2b3b--header--K3cCq","content":"_02712f2b3b--content--_FVGG"};